import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { setAppCustomTitle } from "../../reducers/ThemeOptions";
import Common from "../Common";
import { Button, Card, CardBody, Input, Col, Row } from "reactstrap";
import Tabs from "react-responsive-tabs";
import { useForm, Controller } from "react-hook-form";
import { DefaultMessage } from "./assets/Constants";
import "./assets/index.css";
import Switch from "react-switch";  
import ToolProperty from "./ToolsProperty";
import requestApi from "../../services/requestApi.service";
import { convertKeyValue, formatToolProperty, getSessionValue, handleErrorResponse, showToast, translateContent,CheckUlrValid, getEmptyRemovedValue, getPopupFromDemoAccount, isMobile } from "../../Common/Appcommon";
import { createTool, updateTool} from "../Agents/ProviderDetails";

const CreateTool = ({ onClose, rowData }) => {
    const { handleSubmit, control, formState: { errors }, trigger, setError, clearErrors } = useForm();
    const [formData, setFormData] = useState({timeout_sec:120});
    const [headerDetails, setHeaderDetails] = useState([]);
    const [properties, setProperties] = useState([{ name: "", type: "string", description: "",children: []}])
    const [isChecked,setIsChecked] = useState(false);
    const [propertiesRequered, setPropertiesRequered] = useState([]);
    const [isUpdate,setIsUpdate] = useState(false);
    const [fid,setFid] = useState("");
    const [showLoader,setShowLoader] = useState(false);
    const proName = getSessionValue("agent_provider_name");
    const processData = async (rowData) =>{
        setShowLoader(true);
        let Data = rowData['data_row'];  
        let server = JSON.parse(Data['server']);
        let message = JSON.parse(Data['messages']);
        let param = JSON.parse(Data['parameters']);
        let name = Data['name'];
        let desc = Data['description'];
        let async = Data['isAsync'];
        let id = Data['functionId'];
        let formatHeader = server.headers === "" ? await convertKeyValue(server.headers,true) : [];
        let properties = param?.properties ;
        let required = param?.required ;
        let formattedProperties = properties !== undefined ||  properties !== "" ? await formatToolProperty(properties,required,true) : ""; 
        setIsChecked(async === "1" ? true : false);
        setHeaderDetails(formatHeader);
        if(formattedProperties.required && formattedProperties.nestedProperties){
            setPropertiesRequered(formattedProperties.required);
            setProperties(formattedProperties.nestedProperties);
        }
        setFid(id)
        let formData = {
            server_url: server.url || "", 
            timeout_sec: server.timeoutSeconds || 0,
            start_msg: message[0]?.content || "",
            success_msg: message[1]?.content || "",
            error_msg: message[2]?.content || "",
            delay_msg: message[3]?.content || "",
            tool_name: name || "",  
            tool_desc: desc || "",  
        };
        setIsUpdate(true);        
        setFormData(formData);
        setShowLoader(false);
    }

    useEffect(() => {
        if(rowData){
            processData(rowData);
        }
    }, []);
    
    const handleInputChange = (e, index = null) => {
        const { name, value } = e.target;
        if (index !== null) {
            const updatedHeaders = [...headerDetails];
            updatedHeaders[index] = { ...updatedHeaders[index], [name]: value };
            setHeaderDetails(updatedHeaders);
        } else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const handleSwitchChange = (checked) =>{
        setIsChecked(checked);
    }

    const addHeader = () => {
        setHeaderDetails([...headerDetails, { key: '', value: '' }]);
    };

    const removeHeader = (index) => {
        const updatedHeaders = headerDetails.filter((_, i) => i !== index);
        setHeaderDetails(updatedHeaders);
    };

    const onAddProperty = (newProperty, parentPath = null) => {
        const updateProperties = (props, path) => {
            if (!path) {
                return [...props, newProperty];
            }
            const [current, ...rest] = path.split(".");
            const index = parseInt(current, 10);

            return props.map((item, idx) =>
                idx === index
                ? {
                    ...item,
                    children: updateProperties(item.children || [], rest.join(".")),
                    }
                : item
            );
        };
        setProperties((prev) => updateProperties(prev, parentPath));
    };

    const onUpdateProperty = (path, field, value) => {
        const updateProperties = (props, path) => {
          const [current, ...rest] = path.split(".");
          const index = parseInt(current, 10);
          return props.map((item, idx) =>
            idx === index
              ? rest.length === 0
                ? { ...item, [field]: value }
                : {
                    ...item,
                    children: updateProperties(item.children || [], rest.join(".")),
                  }
              : item
          );
        };
        setProperties((prev) => updateProperties(prev, path));
    };

    const onRemoveProperty = (path) => {
        const updateProperties = (props, path) => {
          const [current, ...rest] = path.split(".");
          const index = parseInt(current, 10);
          if (rest.length === 0) {
            return props.filter((_, idx) => idx !== index);
          }
          return props.map((item, idx) =>
            idx === index
              ? {
                  ...item,
                  children: updateProperties(item.children || [], rest.join(".")),
                }
              : item
          );
        };
        clearErrors(`property_${path}_name`);
        clearErrors(`property_${path}_description`);
        setProperties((prev) => updateProperties(prev, path));
    };

    const onRequiredProperty = (selectedOption) => {
        setPropertiesRequered(selectedOption)
    };

    const subTableByHeader = {
        H1: [
            {
                name: "Server URL",
                icon: "fi fi-rr-link-alt",
                component: (
                    <>
                        <Controller
                            name="server_url"
                            control={control}
                            rules={{ required: formData.server_url === undefined || formData.server_url === null || formData.server_url === "" ? "Server URL is required" : "" }}
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    id="serverUrl" 
                                    name="server_url"
                                    value = {formData.server_url || ""}
                                    placeholder="Enter the API endpoint for this action."
                                    className={`form-control ${errors.server_url ? "is-invalid" : ""}`}
                                    onChange={(e) => {
                                        e.target.value = getEmptyRemovedValue(e.target.value);
                                        field.onChange(e);
                                        handleInputChange(e);
                                    }}
                                />
                            )}
                        />
                        {errors.server_url && (
                            <em className="error invalid-feedback">{errors.server_url.message}</em>
                        )}
                    </>
                ),
            },
            {
                name: "Timeout (secs)",
                icon: "fi fi-rr-clock-nine",
                component: (
                    <>
                        <div className="header-desc mb-2">
                            Set the max wait time (1–120 seconds). {/*Default value: 120*/}
                        </div>
                        <Controller
                            name="timeout_sec"
                            control={control}
                            rules={{
                                required: formData.timeout_sec  === undefined || formData.timeout_sec === null || formData.timeout_sec === "" ? "Timeout is required" : "",
                                min: { value: 1, message: "The timeout duration must be greater than 1 second" },
                                max: { value: 120, message: "Timeout must be between 1 and 120 seconds." },
                            }}
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    id="timeout_sec"
                                    name="timeout_sec"
                                    pattern="[0-9]*"
                                    value = {formData.timeout_sec || ""}
                                    placeholder="Timeout (1-120)"
                                    className={`form-control ${errors.timeout_sec ? "is-invalid" : ""}`}
                                    onChange={(e) => {
                                        const numberonly = /^[0-9]*$/; 
                                        if (!numberonly.test(e.target.value)) {
                                            setError("timeout_sec", {
                                                type: "manual",
                                                message: "Timeout Seconds must be a numerical value.",
                                            });
                                        } else {
                                            field.onChange(e); 
                                            handleInputChange(e);
                                            clearErrors("timeout_sec"); 
                                        }
                                    }}
                                />
                            )}
                        />
                        {errors.timeout_sec && (
                            <em className="error invalid-feedback">{errors.timeout_sec.message}</em>
                        )}
                    </>
                ),
            },
            /*{
                name: "Connect to API into API Headers (Optional)",
                icon: "fi fi-rr-api",
                component: (
                    <>
                      <div className="header-desc">Add custom headers for the API request</div>
                      {headerDetails.length > 0 && (
                        <div className="d-flex align-items-center mt-2">
                          <Col md={4} className="me-2"><label className="form-label">Key</label></Col>
                          <Col md={4} className="me-2"><label className="form-label">Value</label></Col>
                        </div>
                      )}
                      {headerDetails.map((header, index) => (
                        <div className="d-flex align-items-center mt-1" key={index}>
                          <Col md={3} className="me-2">
                            <Input
                              name="key"
                              value={header.key}
                              onChange={(e) => handleInputChange(e, index)}
                              className="form-control"
                              placeholder="Enter key"
                            />
                          </Col>
                          <Col md={3} className="me-2">
                            <Input
                              name="value"
                              value={header.value}
                              onChange={(e) => handleInputChange(e, index)}
                              className="form-control"
                              placeholder="Enter value"
                            />
                          </Col>
                          <Col md={2} className="me-2 d-flex align-items-center">
                            <i
                              className="fi fi-rr-minus-circle icon-color cursor-pointer"
                              onClick={() => removeHeader(index)}
                            />
                          </Col>
                        </div>
                      ))}
                      <div className="mt-3">
                        <Button onClick={addHeader} className="btn-hover-shine theme-bg-g custom-display">
                            Add Header
                        </Button>
                      </div>
                    </>
                )
            },*/
        ],
        H4: [
            {
                name: "Start Message",
                component: (
                    <>
                        <Row>
                            <Col md={12}>
                                <Controller
                                    name="start_msg"
                                    control={control}
                                    rules={{ required: false}}// formData.start_msg === undefined || formData.start_msg === null || formData.start_msg === "" ? "Start Message is required" : ""}}
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            id="start_msg"
                                            name="start_msg"
                                            value={formData.start_msg || ""}
                                            placeholder="Message to show when the tool starts running (e.g. 'Fetching user information...')"
                                            className={`form-control ${errors.start_msg ? "is-invalid" : ""}`}
                                            onChange={(e) => {
                                                e.target.value = getEmptyRemovedValue(e.target.value);
                                                field.onChange(e);
                                                handleInputChange(e, null);
                                            }}
                                        />
                                    )}
                                />
                                {errors.start_msg && (
                                    <em className="error invalid-feedback">{errors.start_msg.message}</em>
                                )}
                            </Col>
                        </Row>
                    </>
                ),
            },
            {
                name: "Delayed Response Message",
                component: (
                    <>
                        <Row>
                            <Col md={12}>
                                <Controller
                                    name="delay_msg"
                                    control={control}
                                    rules={{ required: false}} //formData.delay_msg === undefined || formData.delay_msg === null || formData.delay_msg === "" ? "Delayed Response Message is required" : "" }}
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            id="delay_msg"
                                            name="delay_msg"
                                            value={formData.delay_msg || ""}
                                            placeholder="Message to show when the response is taking longer than expected"
                                            className={`form-control ${errors.delay_msg ? "is-invalid" : ""}`}
                                            onChange={(e) => {
                                                e.target.value = getEmptyRemovedValue(e.target.value);
                                                field.onChange(e);
                                                handleInputChange(e, null);
                                            }}
                                        />
                                    )}
                                />
                                {errors.delay_msg && (
                                    <em className="error invalid-feedback">{errors.delay_msg.message}</em>
                                )}
                            </Col>
                        </Row>
                    </>
                ),
            },
            {
                name: "Success Message",
                component: (
                    <>
                        <Row>
                            <Col md={12}>
                                <Controller
                                    name="success_msg"
                                    control={control}
                                    rules={{ required: false}}// formData.success_msg === undefined || formData.success_msg === null || formData.success_msg === "" ? "Success Message is required" : "" }}
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            id="success_msg"
                                            name="success_msg"
                                            value={formData.success_msg || ""}
                                            placeholder="Message to show when the tool completes successfully"
                                            className={`form-control ${errors.success_msg ? "is-invalid" : ""}`}
                                            onChange={(e) => {
                                                e.target.value = getEmptyRemovedValue(e.target.value);
                                                field.onChange(e);
                                                handleInputChange(e, null, "success_msg");
                                            }}
                                        />
                                    )}
                                />
                                {errors.success_msg && (
                                    <em className="error invalid-feedback">{errors.success_msg.message}</em>
                                )}
                            </Col>
                        </Row>
                    </>
                ),
            },
            {
                name: "Error Message",
                component: (
                    <>
                        <Row>
                            <Col md={12}>
                                <Controller
                                    name="error_msg"
                                    control={control}
                                    rules={{ required: false}}// formData.error_msg === undefined || formData.error_msg === null || formData.error_msg === "" ? "Error Message is required" : "" }}
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            id="error_msg"
                                            name="error_msg"
                                            value={formData.error_msg || ""}
                                            placeholder="Message to show if the tool execution fails"
                                            className={`form-control ${errors.error_msg ? "is-invalid" : ""}`}
                                            onChange={(e) => {
                                                e.target.value = getEmptyRemovedValue(e.target.value);
                                                field.onChange(e);
                                                handleInputChange(e, null);
                                            }}
                                        />
                                    )}
                                />
                                {errors.error_msg && (
                                    <em className="error invalid-feedback">{errors.error_msg.message}</em>
                                )}
                            </Col>
                        </Row>
                    </>
                ),
            },
        ],
    };

    const getTabsByHeader = (headerKey) =>
        subTableByHeader[headerKey].map(({ name, component, icon,description }, index) => {
            if(headerKey == ""){
                if (name === 'Header' && proName !== 'vapi') {
                    return {}; // Skip this tab if provider is not vapi
                }
            }
    
            return {
                key: index,
                title: (
                    <>
                        <i className={`${icon}`}></i>
                        <span className="ml-2">{name}</span>
                        </>
                ),
                getContent: () => component,
            };
        });
    

    const createNewTool = async () => {
        if (getPopupFromDemoAccount()) {
            return;
        }
        let url = formData.server_url;
         if (!CheckUlrValid(url)) {
            setError("server_url", {
                type: "manual",
                message: "Invalid URL format",
            });
            return;
        }else if(formData.timeout_sec <= 0 || !formData.timeout_sec){
            handleErrorResponse(translateContent("vm.agent.tools.timeout.error"));
            return;
        }
        setShowLoader(true);
        let formatedproperty = await formatToolProperty(properties,propertiesRequered);
        let formatedHeader = await convertKeyValue(headerDetails);
        let OPERATION = "";
        let msg = "";
        let res = [];
        let params = {
            ...(isUpdate ? {} : { type: "function" }),
            async:isChecked,
            function:{
                name:formData.tool_name,
                description:formData.tool_desc,
                parameters:formatedproperty
            },
            messages:[
                {
                    type :'request-start',
                    content:formData.start_msg,//DefaultMessage.startMessage,//
                },{
                    type: "request-complete",
                    content:formData.success_msg,//DefaultMessage.successMessage,//
                },{
                    type: "request-failed",
                    content:formData.error_msg,//DefaultMessage.failMessage,//
                },{
                    type: "request-response-delayed",
                    content:formData.delay_msg,//DefaultMessage.delayMessage,//
                }
            ],
            server:{
                url:formData.server_url,
                timeoutSeconds:parseInt(formData.timeout_sec, 10),
                headers:formatedHeader
            }
        }
        if(isUpdate){
            let uparam = {
                id:fid,
                param:params
            }
            if(proName === 'vapi'){
                res = await updateTool(proName,uparam);
            }else{
                params['id'] = fid;
            }
            OPERATION="UPDATE_TOOL_DETAIL";
            msg="Updated";
        }else{
            if(proName === 'vapi'){
                res = await createTool(proName,params);
            }
            OPERATION="CREATE_TOOL_DETAIL";
            msg="Created";
        }
        if(proName === 'vapi' && !res.issuccess){
            return;
        }
       
        // if (res.issuccess) {
            let reqobj = {
                ENTITY: "AIPROCESSOR",
                OPERATION: OPERATION,
                provider: proName,
                FORMDATA: proName === 'vapi' ? res.data : params,
                isSystem:'1',
            };
            const response = await requestApi.processServerRequest(reqobj);
            const message = response.issuccess
                ? (isUpdate ? translateContent("vm.custom.action.update") : translateContent("vm.custom.action.create"))
                : `Unable to ${msg}`;
            const toastType = response.issuccess ? "success" : "error";
            showToast(message, 'top-right', toastType);
            if(response.issuccess){ 
                onClose();
            }
        // }
        setShowLoader(false);

    };

    const onSubmit = async (data) => {   
        const isValid = await trigger();
        if(isValid){
            createNewTool();
        }
    };

    const getFieldsContent = () => (
        <div className="w-100 custome-tools">
            <div className="agency-details">
                {
                    isMobile() && getTitleBody()
                }
                <div className="field-details">
                    <Card className="card-br">
                        <CardBody className="pb-6 card-fields">
                            <div className="card-fields profile-title-info d-grid">
                                <div className="tool-heading">
                                    <i class="fi fi-rr-tools"></i>
                                    <span className="ml-2">What’s this action for?</span>
                                </div>
                                <div className="header-desc">
                                    Describe the action so the AI knows when and how to use it.
                                </div>
                            </div>
                            <div className="tool-heading-desc">
                                Name
                            </div>
                            <div className="mt-2">
                                <Controller
                                    name="tool_name"
                                    control={control}
                                    rules={{ required: formData.tool_name === undefined || formData.tool_name === null || formData.tool_name === "" ? "Action name is required." : "" }}
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            id="tool_name"
                                            name="tool_name"
                                            value={formData.tool_name || ""}
                                            placeholder="Give your action a name (e.g., getUserInfo, lookupEmail)."
                                            className={`form-control ${errors.tool_name ? "is-invalid" : ""}`}
                                            onChange={(e) => {
                                                let value = e.target.value;
                                                if(value === ''){
                                                    field.onChange(e);
                                                    handleInputChange(e);
                                                    clearErrors("tool_name");
                                                    return;
                                                }
                                                const toolNamePattern = /^[a-zA-Z0-9_-]{1,64}$/;
                                                if (!toolNamePattern.test(e.target.value)) {
                                                    setError("tool_name", {
                                                        type: "manual",
                                                        message: "Action name must be 1-64 characters and only contain letters, numbers, hyphens, or underscores",
                                                    });
                                                } else {
                                                    field.onChange(e);
                                                    handleInputChange(e);
                                                    clearErrors("tool_name");
                                                }
                                            }}
                                        />
                                    )}
                                />
                                {errors.tool_name && (
                                    <em className="error invalid-feedback">{errors.tool_name.message}</em>
                                )}
                            </div>
                            <div className="tool-heading-desc">
                                Description
                            </div>
                            <div className="mt-2">
                                <Controller
                                    name="tool_desc"
                                    control={control}
                                    rules={{ required: formData.tool_desc === "" || formData.tool_desc === undefined || formData.tool_desc === null ? "Description is required." : ""}}
                                    render={({ field }) => (
                                        <textarea
                                            {...field}
                                            id="tool_desc"
                                            name="tool_desc"
                                            value={formData.tool_desc || ""}
                                            placeholder="Briefly explain what the action does."
                                            className={`form-control ${errors.tool_desc ? "is-invalid" : ""}`}
                                            rows="3"
                                            maxLength="1000"
                                            onChange={(e) => {
                                                e.target.value = getEmptyRemovedValue(e.target.value);
                                                field.onChange(e);
                                                handleInputChange(e);
                                            }}
                                        />
                                    )}
                                />
                                {errors.tool_desc && (
                                    <em className="error invalid-feedback">{errors.tool_desc.message}</em>
                                )}
                            </div>
                            {proName === "vapi" && (
                                <>
                                    {/* <div className="tool-heading mt-3">
                                        Optional
                                    </div> */}
                                </>
                            )}
                            <div className="mt-2">
                                <Tabs 
                                    tabsWrapperClass="body-tabs" 
                                    activeTab="1" 
                                    showMore={true} 
                                    transform={true} 
                                    showInkBar={true} 
                                    selectedTabKey={0} 
                                    transformWidth={600} 
                                    items={getTabsByHeader("H1")} 
                                />
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </div>

            <div className="agency-details">
                <div className="field-details">
                    <Card className="card-br">
                        <CardBody className="pb-6 card-fields">
                            <div className="card-fields profile-title-info d-grid">
                                <div className="tool-heading">
                                    <i class="fi fi-rr-build-alt"></i>
                                    <span className="ml-2">Schema</span>
                                </div>
                                <div className="header-desc">
                                    Define the input/output format for the action.
                                </div>
                            </div>
                            <ToolProperty
                                properties={properties}
                                requiredProperties={propertiesRequered}
                                onAddProperty={onAddProperty}
                                onUpdateProperty={onUpdateProperty}
                                onRemoveProperty={onRemoveProperty}
                                onRequiredProperty={onRequiredProperty}
                                control={control}
                                clearErrors={clearErrors}
                            />
                        </CardBody>
                    </Card>
                </div>
            </div>
            {/*<div className="agency-details">
                <div className="card-fields pb-3 d-grid">
                    <span className="heading layout-title">Create a Tool</span>
                </div>
                <div className="field-details">
                    <Card className="card-br">
                        <CardBody className="pb-6 card-fields">
                            <div className="card-fields profile-title-info d-grid">
                                <div className="tool-heading">Connect to API</div>
                                <div className="header-desc">
                                    Link your function to a backend API.
                                </div>
                            </div>
                            <Tabs 
                                tabsWrapperClass="body-tabs" 
                                activeTab="1" 
                                showMore={true} 
                                transform={true} 
                                showInkBar={true} 
                                selectedTabKey={0} 
                                transformWidth={600} 
                                items={getTabsByHeader("H1")} 
                            />
                        </CardBody>
                    </Card>
                </div>
            </div>*/}
            {
                proName === "vapi" && (
                    <div className="agency-details">
                        <div className="field-details">
                            <Card className="card-br">
                                <CardBody className="card-fields">
                                    <Row>
                                        <Col md={10} className="d-flex align-items-center">
                                            <div>
                                                <div className="tool-heading"><i class="fi fi-rr-build-alt"></i> Async Tool (Optional)</div>
                                                <div className="tool-heading-desc">
                                                Enable this option if you want the agent to trigger your server without waiting for a response. Useful for fire-and-forget actions where no response is required to proceed.
                                                </div> 
                                            </div>
                                        </Col>
                                        <Col md={2} className="d-flex align-items-center">
                                            <div className="d-flex justify-content-end">
                                                <Switch
                                                    height={20}
                                                    width={40}
                                                    onColor={"#034737"}
                                                    name="switch"
                                                    checked={isChecked}
                                                    onChange={handleSwitchChange}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                )
            }
            {proName === "vapi" && (
                <div className="agency-details">
                    <div className="field-details">
                        <Card className="card-br">
                            <CardBody className="pb-6 card-fields">
                                <div className="card-fields profile-title-info d-grid">
                                    <div className="tool-heading">
                                        <i class="fi fi-rr-messages"></i>
                                        <span className="ml-2">
                                            What messages should be shown to the user as the tool is running?    (optional) 
                                        </span>
                                    </div>
                                    <div className="header-desc">
                                        Configure the messages that should be shown to the user as the tool is running.
                                    </div>
                                </div>
                                <Tabs 
                                    tabsWrapperClass="body-tabs" 
                                    activeTab="1" 
                                    showMore={true} 
                                    transform={true} 
                                    showInkBar={true} 
                                    selectedTabKey={0} 
                                    transformWidth={600} 
                                    items={getTabsByHeader("H4")} 
                                />
                            </CardBody>
                        </Card>
                    </div>
                </div>
            )}
        </div>
    );

    const getMainContent = () =>{
        return(
            <form onSubmit={handleSubmit(onSubmit)} className="w-100">
                {getFieldsContent()}
            </form>
        );
    }

    const getTitleBody = () => {
        return(
            <>
                <div className='settings-phonenumber-titlebody'>
                    <Button onClick={onClose} className="badge  text-capitalize badge-theme badge-btn custom-display w-50">
                        <i className={"fi fi-rr-cross-circle icon-with-txt me-2"}></i>Cancel
                    </Button>
                    <Button className="btn-hover-shine theme-bg-g custom-display add-btn me-auto me-3 w-50 gap-2" type="submit" onClick={handleSubmit(onSubmit)}>
                        <i className={"fi fi-rr-bookmark icon-with-txt"}></i> {`${isUpdate ? "Update" : "Save"}`}
                    </Button>
                </div>
            </>
        );
    };

    return (
        <div className="full-page-container">
            <Common 
                mainLoader={showLoader}
                title="Custom Action" 
                titleContent="Custom Action" 
                titleBody={!isMobile() && getTitleBody()} 
                mainContent={getMainContent()} 
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle,
});

const mapDispatchToProps = (dispatch) => ({
    setAppCustomTitle: (title) => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateTool);